import React from 'react';
import Modal from 'components/Modal/Modal';

import {
    Text, Box, Button, Link
} from 'components/ui';
import addressConstants from 'constants/Address';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import store from 'store/Store';
import actions from 'Actions';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import ModalsEN from 'components/GlobalModals/locales/modals_en_US';
import ModalsFR from 'components/GlobalModals/locales/modals_fr_CA';

const { getLocalisedDataFromResource, COUNTRY_LONG_NAMES } = LanguageLocaleUtils;
const { showAddressVerificationModal } = actions;

class AddressVerificationModal extends BaseClass {
    constructor(props) {
        super(props);

        this.addressConstantsTexts = addressConstants(props.isReleaseThreeVerifyAddressModal);
    }
    handleDismiss = () => {
        const { cancelCallback } = this.props;
        this.requestClose(cancelCallback);
    };

    handleEditAddress = () => {
        const { successCallback } = this.props;
        this.requestClose(successCallback);
    };

    handleUseAddress = () => {
        const { cancelCallback } = this.props;
        this.requestClose(cancelCallback);
    };

    render() {
        const getText = getLocalisedDataFromResource(ModalsEN, ModalsFR);
        const { isOpen, verificationType, currentAddress, recommendedAddress } = this.props;
        const { BUTTON_TEXT, TITLE, LEGEND, DATA_AT } = this.addressConstantsTexts.ADDRESS_VERIFICATION_MODAL[verificationType];

        return (
            <Modal
                isOpen={isOpen}
                onDismiss={this.handleDismiss}
                width={420}
                dataAt={DATA_AT}
                isDrawer={true}
            >
                <Modal.Header>
                    <Modal.Title>{TITLE}</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    lineHeight='tight'
                    paddingBottom={[5, 4]}
                >
                    {LEGEND && (
                        <Text
                            is='p'
                            fontSize='md'
                            marginBottom={5}
                            children={LEGEND}
                        />
                    )}
                    <Text
                        is='p'
                        marginBottom={1}
                        fontWeight='bold'
                        children={getText('youEntered')}
                    />
                    {this.renderAddress(currentAddress)}
                    {recommendedAddress && (
                        <Box
                            data-at={'recommend_address'}
                            marginTop={4}
                            marginBottom={[4, 5]}
                        >
                            <Text
                                is='p'
                                fontWeight='bold'
                                marginBottom={1}
                                children={getText('recommended')}
                            />
                            {this.renderAddress(recommendedAddress)}
                        </Box>
                    )}
                    <Button
                        data-at={Sephora.debug.dataAt('edit_address_btn')}
                        variant='primary'
                        block={true}
                        marginTop={[4, 5]}
                        marginBottom={4}
                        onClick={this.handleEditAddress}
                        children={BUTTON_TEXT}
                    />
                    <Link
                        data-at={Sephora.debug.dataAt('use_address_btn')}
                        display='block'
                        padding={2}
                        margin={-2}
                        color='blue'
                        onClick={this.handleUseAddress}
                    >
                        {getText(recommendedAddress || this.props.isReleaseThreeVerifyAddressModal ? 'keepAsEntered' : 'useTheAddress')}
                    </Link>
                </Modal.Body>
            </Modal>
        );
    }

    renderAddress = address => {
        return (
            <React.Fragment>
                {address.address1}
                <br />
                {address.address2 && (
                    <React.Fragment>
                        {address.address2}
                        <br />
                    </React.Fragment>
                )}
                {address.city}, {address.state} {address.postalCode}
                <br />
                {!this.props.isReleaseThreeVerifyAddressModal && COUNTRY_LONG_NAMES[address.country]}
            </React.Fragment>
        );
    };

    requestClose = callback => {
        store.dispatch(showAddressVerificationModal({ isOpen: false }));

        if (typeof callback === 'function') {
            callback();
        }
    };
}

export default wrapComponent(AddressVerificationModal, 'AddressVerificationModal', true);
